<div class="label label-warning" *ngIf="checkPrivileges()">
	Privileges are enabled: {{ privileges.join(', ') }}
	<a style="cursor: pointer;" (click)="cancelPrivileges()">cancel</a>
</div>